/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './coupon-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-coupon-list-page',
  template
})
export class CouponListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.coupons.coupon';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'couponCode', param: 'code'},
    {label: 'validity', param: '', sortable: false},
    {label: 'status', param: 'couponStatus'},
    {param: 'validFrom'},
    {param: 'validTo'},
    {label: 'discount', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
